import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import BusinessInfoSettings from "./infoSettings";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const BusinessUpdate = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Business Update</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <BusinessInfoSettings />
                </div>
            </div>
        </div>
        
    );
}

export default BusinessUpdate;
